import React from "react";
import Select, { StylesConfig, SingleValue, MultiValue } from "react-select";

interface Option {
  value: string | number | boolean;
  label: string;
}

interface ReactSelectProps {
  label?: string;                 // optional label
  options: Option[];
  value: Option | Option[] | null;
  onChange: (option: Option | null) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isMulti?: boolean;
}

const customStyles: StylesConfig<Option, boolean> = {
  control: (provided) => ({
    ...provided,
    minHeight: "38px",
    borderRadius: "0.75rem",
    borderColor: "#d4d4d8",
    boxShadow: "none",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "0.875rem",
  }),
};




const ReactSelect: React.FC<ReactSelectProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder = "Select...",
  isDisabled = false,
  isMulti = false,
}) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      {label && <label className="text-xs font-semibold text-gray-500">{label}</label>}
       <Select<Option, boolean>
        options={options}
        value={value}
        isMulti={isMulti}
        onChange={(
          option: SingleValue<Option> | MultiValue<Option>
        ) => onChange(option as any)}
        styles={customStyles}
        placeholder={placeholder}
        isDisabled={isDisabled}
        closeMenuOnSelect={!isMulti}
      />
    </div>
  );
};

export default ReactSelect;
